import type { Template } from "@/types";

export const LA_03_H2_V1: Template[] = [
    {
        id: "la-03-h2v1-01",
        name: "LA 01 - H2V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h2_v1_01.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 174, y: 37, width: 329, height: 456, rotation: 0, imageRotation: 0 },
            { id: "2", x: 833, y: 36, width: 361, height: 226, rotation: 0, imageRotation: 0 },
            { id: "3", x: 833, y: 270, width: 361, height: 225, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h2v1-02",
        name: "LA 02 - H2V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h2_v1_02.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 172, y: 43, width: 332, height: 448, rotation: 0, imageRotation: 0 },
            { id: "2", x: 717, y: 162, width: 294, height: 208, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1019, y: 162, width: 294, height: 208, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h2v1-03",
        name: "LA 03 - H2V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h2_v1_03.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 47, y: 40, width: 332, height: 449, rotation: 0, imageRotation: 0 },
            { id: "2", x: 953, y: 40, width: 352, height: 222, rotation: 0, imageRotation: 0 },
            { id: "3", x: 953, y: 270, width: 352, height: 221, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h2v1-04",
        name: "LA 04 - H2V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h2_v1_04.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 162, y: 37, width: 352, height: 225, rotation: 0, imageRotation: 0 },
            { id: "2", x: 162, y: 270, width: 352, height: 224, rotation: 0, imageRotation: 0 },
            { id: "3", x: 852, y: 37, width: 324, height: 456, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h2v1-05",
        name: "LA 05 - H2V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h2_v1_05.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 40, y: 159, width: 294, height: 216, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 159, width: 294, height: 216, rotation: 0, imageRotation: 0 },
            { id: "3", x: 849, y: 43, width: 330, height: 448, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h2v1-06",
        name: "LA 06 - H2V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h2_v1_06.png",
        size: [1325, 520],
        style: {},
        slots: [         
            { id: "1", x: 0, y: 81, width: 526, height: 358, rotation: 0, imageRotation: 0 },
            { id: "2", x: 534, y: 81, width: 259, height: 358, rotation: 0, imageRotation: 0 },
            { id: "3", x: 801, y: 81, width: 524, height: 358, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h2v1-07",
        name: "LA 07 - H2V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h2_v1_07.png",
        size: [1325, 520],
        style: {},
        slots: [
            { id: "1", x: 62, y: 98, width: 476, height: 324, rotation: 0, imageRotation: 0 },
            { id: "2", x: 546, y: 98, width: 234, height: 324, rotation: 0, imageRotation: 0 },         
            { id: "3", x: 788, y: 98, width: 475, height: 324, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h2v1-08",
        name: "LA 08 - H2V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h2_v1_08.png",
        size: [1325, 520],
        style: {},
        slots: [        
            { id: "1", x: 0, y: 81, width: 526, height: 358, rotation: 0, imageRotation: 0 },
            { id: "2", x: 534, y: 81, width: 525, height: 358, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1067, y: 81, width: 258, height: 358, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "la-03-h2v1-09",
        name: "LA 09 - H2V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h2_v1_09.png",
        size: [1325, 520],
        style: {},
        slots: [
            { id: "1", x: 62, y: 98, width: 234, height: 324, rotation: 0, imageRotation: 0 },     
            { id: "2", x: 304, y: 98, width: 476, height: 324, rotation: 0, imageRotation: 0 },
            { id: "3", x: 788, y: 98, width: 475, height: 324, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "la-03-h2v1-10",
        name: "LA 10 - H2V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h2_v1_10.png",
        size: [1325, 520],
        style: {},
        slots: [
            { id: "1", x: 62, y: 98, width: 475, height: 324, rotation: 0, imageRotation: 0 },        
            { id: "2", x: 545, y: 98, width: 476, height: 324, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1029, y: 98, width: 234, height: 324, rotation: 0, imageRotation: 0 },       
        ],
    }
];